import { Icon24FigmaLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const FigmaMonoLogoLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 7c0 1.043.533 1.963 1.341 2.5A3 3 0 0 0 6.5 12c0 1.043.533 1.963 1.341 2.5A3 3 0 1 0 12.5 17v-2.764A3 3 0 1 0 16.159 9.5 3 3 0 0 0 14.5 4h-5a3 3 0 0 0-3 3m8 2a2 2 0 1 0 0-4h-2v4zm-2 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0m-1 2h-2a2 2 0 1 1 0-4h2zm-2 1h2v2a2 2 0 1 1-2-2m2-6h-2a2 2 0 1 1 0-4h2z"
      />
    </svg>
  );
};

export const FigmaMonoLogo = fplIcon(FigmaMonoLogoLocal, Icon24FigmaLarge);
